import { render, staticRenderFns } from "./InputPhone.vue?vue&type=template&id=21ea7da3&scoped=true&"
import script from "./InputPhone.vue?vue&type=script&lang=js&"
export * from "./InputPhone.vue?vue&type=script&lang=js&"
import style0 from "./InputPhone.vue?vue&type=style&index=0&id=21ea7da3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ea7da3",
  null
  
)

export default component.exports